// import branch from 'branch-sdk';
import moment from 'moment-timezone';
import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { SET_WIDGET_STRIPE_ACCOUNT } from 'store/reducers/widgetReducer'
import analytics from 'util/analytics';
import "./ClassCheckout.scss";
import { getOfferingCheckout } from 'util/api/CheckoutAPI'
import { useAuth } from 'util/auth'
import {LoginSignupForm} from 'components/AccountButton'
import { checkoutOffering } from 'util/api/CheckoutAPI'
import CardSection from 'components/CardSection'
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import PaymentMethodSelector from 'components/PaymentMethodSelector'
import CheckoutPricingSection from 'components/CheckoutPricingSection'
import {Helmet} from 'react-helmet'
import {ExpandableTerms} from 'components/ClassCheckout'
import PreviewImage from 'components/PreviewImage'
import './offeringCheckout.scss'
import {sendNewError} from 'util/slackbot'
import OfferingSelector from 'components/OfferingSelector'
import {calculateDiscountFrom} from 'components/CheckoutPricingSection'
import {frequencyFromExpiresIn} from 'components/NewOfferingButton'
import {CustomFormFields} from 'components/ClassCheckout'
var HtmlToReactParser = require('html-to-react').Parser;
var htmlToReactParser = new HtmlToReactParser(); 

function OfferingCheckout(props) {

    const auth = useAuth()
    const stripe = useStripe()
    const elements = useElements()
    const dispatch = useDispatch()
    const [takeonfee, settakeonfee] = useState(true);
    const [marketingEmails, setMarketingEmails] = useState(true);
    const [agreeToTerms, setAgreeToTerms] = useState(false);
    const stripeAccountId = useSelector(state => state.widget.stripeAccount) // JARCH Stripe account
    const [isLoading, setIsLoading] = useState(false)
    const [selectedPaymentMethod, setSelectedPaymentMethod] = React.useState(null)
    const [selectedPricingOption, setSelectedPricingOption] = React.useState(null)
    const currency = useSelector(state => state.widget.instructor.instructorProfile?.currency ?? "USD");
    const currencyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
    });

    const offeringId = props.match.params.platformID ?? props.challengeId
    // console.log("offering match: ", props.match.params)

    moment.locale('en', {
        calendar : {
            lastDay : '[Yesterday]',
            sameDay : '[Today]',
            nextDay : '[Tomorrow]',
            lastWeek : '[last] dddd [at] LT',
            nextWeek : 'dddd [at] LT',
            sameElse : 'dddd MMM Do'
        }
    });

    var selectedOffering = useSelector(state => state.widget.offerings?.find(val => val.id === offeringId));
    const [apiOffering, setApiOffering] = React.useState(null)
    if (apiOffering) {
        selectedOffering = apiOffering
    }
    const selectedInstructor = useSelector(state => state.widget.instructor);
    useEffect(() => {
        analytics.page({
            title: 'Offering Checkout'
        })
        analytics.track("Pre Purchase Viewed", {...selectedOffering})
    }, [selectedOffering])

    const [checkoutModel, setCheckoutModel] = React.useState({}) // JARCH: drop-in, class pack, etc.. 
    const [userCouponCode, setUserCouponCode] = React.useState(null)
    const handleCouponCodeChange = (couponCode) => {
        setUserCouponCode(couponCode)
    }

    const handleCouponCodeApply = () => {
        setIsLoading(true)
        getOfferingCheckout(offeringId, userCouponCode)
            .then(data => {
                setIsLoading(false)
                if (data?.success === false) {
                    console.log("Error fetching checkout: ", data)
                    if (data?.message) {
                        window.alert(data.message)
                    }
                    return
                }
                // console.log(data)
                setCheckoutData(data)
                if (data.offering) {
                    setApiOffering(data.offering)
                    const offeringModel = {
                        dropIn: false,
                        offeringId: data.offering.id,
                        type: data.offering.type,
                        payment: Number(data.offering.price),
                        promoCode: data.offering.promoCode,
                        promoCodePurchaseOnly: data.offering.promoCodePurchaseOnly ? true : false,
                        dollarDiscount: Number(data.offering.dollarDiscount),
                        offering: {
                            ...data.offering
                        }
                    }
                    if (data.offering?.frequency !== "subscription") {
                        
                        if (selectedPricingOption) {
                            // FIXES issue where promo code is not applied to selection pricing option
                            setCheckoutModel({
                                ...offeringModel,
                                pricingOption: selectedPricingOption
                            })
                        } else {
                            setCheckoutModel(offeringModel)
                        }
                        
                    }
                }
            })
            .catch(err => {
                setIsLoading(false)
                // if (err.message)
                console.log("Error fetching checkout: ", err)
            })
    }
    const [checkoutData, setCheckoutData] = React.useState(null) // data from checkout
    useEffect(() => {
        setIsLoading(true)
        getOfferingCheckout(offeringId, userCouponCode)
            .then(data => {
                setIsLoading(false)
                if (data?.success === false) {
                    console.log("Error fetching checkout: ", data)
                    if (data?.message) {
                        window.alert(data.message)
                    }
                    return
                }
                console.log("stripeAccount: ", data.stripeAccount)
                dispatch({type: SET_WIDGET_STRIPE_ACCOUNT, stripeAccount: data?.stripeAccount})
                console.log("CHECKOUT DATA: ", data)
                setCheckoutData(data)
                if (data.offering) {
                    setApiOffering(data.offering)
                    const offeringModel = {
                        dropIn: false,
                        offeringId: data.offering.id,
                        type: data.offering.type,
                        payment: Number(data.offering.price),
                        promoCode: data.offering.promoCode,
                        promoCodePurchaseOnly: data.offering.promoCodePurchaseOnly ? true : false,
                        dollarDiscount: Number(data.offering.dollarDiscount),
                        offering: {
                            ...data.offering
                        }
                    }
                    if (data.offering?.frequency !== "subscription") {
                        // Disable purchasing the original
                        setCheckoutModel(offeringModel)
                    }
                }
            })
            .catch(err => {
                setIsLoading(false)
                // if (err.message)
                console.log("Error fetching checkout: ", err)
            })
    }, [auth])

    var viewModel = {}
    if (selectedOffering) {
        const reactElement = selectedOffering.descriptionHTML ? htmlToReactParser.parse(selectedOffering.descriptionHTML) : null;

        var selectedPrice = selectedOffering.price

        if (checkoutModel) {
            selectedPrice = checkoutModel.payment
        }

        if (selectedPricingOption) {
            selectedPrice = selectedPricingOption.price
        }

        const discount = calculateDiscountFrom(checkoutModel, checkoutData?.couponCodeResponse)
        if (discount) {
            selectedPrice = selectedPrice - discount
        }

        // JARCH
        // console.log("SELECTED PRICE: ", selectedPrice)
        const requirePayment = ((selectedPrice ?? 0) > 0) || (checkoutModel.type === 'subscription' && checkoutModel.payment)

        var frequencyText = null
        // JARCH -- this is where we choose the price
        // var newPayment = null
        if (selectedOffering.type === 'challenge' && userCouponCode === selectedOffering.promoCode && selectedOffering.dollarDiscount) {
            selectedPrice = selectedPrice - selectedOffering.dollarDiscount
        } else if (selectedOffering.type === 'subscription' || selectedOffering.isSubscription === true) {
            frequencyText = frequencyFromExpiresIn(selectedOffering.expiresIn)
        }

        var specialOfferingPricingText = null
        if ((selectedOffering.type === 'subscription' || selectedOffering.isSubscription === true) && selectedOffering.isOneTimeOffer) {
            if (!selectedOffering.frequency) {
                
            } else if (selectedOffering?.discountType === 'firstPeriodDiscount') {
                specialOfferingPricingText = `First ${frequencyText.replace("ly", "")} for ${currencyFormatter.format(selectedOffering.firstPeriodPrice)}, then ${currencyFormatter.format(selectedOffering.price)} ${frequencyText} until canceled.`
    
            } else if (selectedOffering?.discountType === 'freeTrial') {
                specialOfferingPricingText = `First ${selectedOffering?.freeTrialPeriodDays ?? 0} days free, then ${currencyFormatter.format(selectedOffering.price)} ${frequencyText} until canceled.`
            }
        }
        viewModel = {
            promoCodePurchaseOnly: selectedOffering.promoCodePurchaseOnly ? true : false,
            userCouponCode: userCouponCode,
            platformID: selectedOffering.platformID,
            name: selectedOffering.name,
            image: (selectedOffering.images && selectedOffering.images.length > 0) ? selectedOffering.images[0] : "",
            instructorName: selectedInstructor.firstName,
            description: selectedOffering.description,
            descriptionHTML: reactElement,
            priceText: selectedOffering.type === "challenge" ? "" : currencyFormatter.format(selectedOffering.price),
            frequencyText: selectedOffering.type === "challenge" ? "" :frequencyText,
            takeonfee: takeonfee,
            marketingOptIn: marketingEmails,
            agreeToTerms: agreeToTerms,
            // showPayment: selectedPrice > 0,
            showPayment: requirePayment,
            payment: selectedPrice,
            nextbuttonstring: selectedOffering.promoCodePurchaseOnly ? "Access" : (selectedPrice === 0 ? "Purchase for Free" : "Purchase"),
            disableButton: !checkoutData,
            isPurchasable: checkoutData?.isPurchasable ?? true,
            specialOfferingPricingText: specialOfferingPricingText,
            showMarketingOptIn: checkoutData?.showMarketingOptIn,
            formResponse: checkoutData?.formResponse
        }

        if (checkoutData?.requiresWaiver) {
            viewModel.liabilityWaiverText = selectedInstructor?.instructorProfile?.liabilityWaiverTextHTML ?? selectedInstructor?.instructorProfile?.liabilityWaiverText
        }

        if (selectedPricingOption) {
            viewModel.pricingOption = selectedPricingOption
        }

        if (viewModel.promoCodePurchaseOnly) {
            viewModel.payment = 0
            viewModel.showPayment = false
        }
    }

    console.log("VIEW MODEL: ", viewModel)
    
    const { history, match } = props;

    const [formData, setFormData] = React.useState(null)

    function nextButtonClicked() {
        console.log("clicked next")
        // console.log(viewModel)
        if (!auth.userData) {
            window.alert("Must be logged in to book this class")
            return
        }

        if (viewModel.liabilityWaiverText && !viewModel.agreeToTerms) {
            window.alert("Must agree to liability waiver")
            return
        }

        // if (viewModel.liabilityWaiverText && !viewModel.agreeToTerms) {
        //     window.alert("Must agree to liability waiver")
        //     return
        // }

        var dataToCheckout = {
            ...viewModel,
            ...checkoutModel,
            partnerId: (' ' + selectedInstructor.id).slice(1)
        }

        if (formData) {
            dataToCheckout.formData = formData
        }
        // console.log(dataToCheckout)

        // console.log(dataToCheckout)
        // window.alert("Wahoo!")
        checkoutHandler(dataToCheckout)
    }

    
    async function checkoutHandler(val) {

        // console.log("checkout handler: ", val)
        // return

        if (viewModel.promoCodePurchaseOnly && userCouponCode !== selectedOffering.promoCode) {
            window.alert("Incorrect promo code")
            return
        }

        if (viewModel.promoCodePurchaseOnly) {
            val.payment = 0
        }

        if (selectedOffering?.pricingOptions && selectedOffering.pricingOptions.length > 1 && !selectedPricingOption) {
            window.alert("Must select pricing option")
            return
        }

        // console.log("checkout: ", val)
        // return
        setIsLoading(true)
        try {

            let paymentMethod = selectedPaymentMethod?.id
            // if (val.payment > 0) {
            if (val.showPayment) {

                
                if (!selectedPaymentMethod) { // requires payment with new card

                    const cardElement = elements.getElement(CardElement);

                    const paymentMethodReq = await stripe.createPaymentMethod({
                        type: 'card',
                        card: cardElement
                    }, {
                        stripeAccount: stripeAccountId
                    })

                    // console.log("paymentMethodReq: ", paymentMethodReq)

                    if (paymentMethodReq.error?.message) {
                        
                        await sendNewError(JSON.stringify({
                            error: paymentMethodReq.error.message,
                            location: "Creating payment method -- Offering checkout",
                            code: paymentMethodReq.error.code,
                            decline_code: paymentMethodReq.error.decline_code,
                            user: auth?.userData?.email,
                            host_name: selectedInstructor?.firstName,
                            offeringId: offeringId
                        }))
                        setIsLoading(false)
                        window.alert(paymentMethodReq.error.message)
                        return
                    }
                    
                    paymentMethod = paymentMethodReq?.paymentMethod?.id

                    if (val.type === "subscription") {
                        // setup card for future use.. 
                        //      Done server side
                    }
                }

            }
            

            var data = {
                ...val,
                // name: val.name,
                // description: `Class with ${val.instructorName}\n${val.timeString}`,
                // images: val.images,
                // runningTotal: Math.round(val.runningTotal * 100),
                paymentMethod: paymentMethod,
                willTakeOnPayment: val.takeonfee,
                agreeToBeContacted: val.marketingOptIn,
                userID: auth.userData.platformID,
                id: val.platformID,
                bookingType: "offering",
                collection: "purchases",
                bookingLocation: "widget",
                success_url: `${process.env.REACT_APP_BOOKING_SUCCESS_URL}${match.url}/confirm/${val.platformID}`,
                cancel_url: `${process.env.REACT_APP_BOOKING_CANCEL_URL}${match.url}/checkout/${val.platformID}`,
                customer_name: auth.userData.firstName,
                customer_email: auth.userData.email
            }



            // console.log("checkout data: ", data)
            // return


            delete data.descriptionHTML

            // return 
            const response = await checkoutOffering(data.id, data)
            if (!response.success) {
                await sendNewError(JSON.stringify({
                    error: response,
                    user: auth?.userData?.email,
                    host_name: selectedInstructor?.firstName,
                    offeringId: offeringId
                }))
                setIsLoading(false)
                if (response.message?.raw?.message) {
                    window.alert(response.message.raw.message)
                } else {
                    window.alert(response.message)    
                }
                
                return
            }

            const {sessionId, message, reservationId, connectAccountId, clientSecret} = response;

            if (sessionId) {
                setIsLoading(false)
                window.alert("We shouldn't be using sessionId anymore.. ")

            } else if (clientSecret) {

                const confirmedCardPayment = await stripe.confirmCardPayment(clientSecret, {
                    payment_method: paymentMethod,
                    setup_future_usage: "off_session"
                }, {
                    stripeAccount: stripeAccountId
                })

                
                setIsLoading(false)
                if (confirmedCardPayment.error) {
                    console.log(confirmedCardPayment)
                    await sendNewError(JSON.stringify({
                        message: confirmedCardPayment.error.message,
                        user: auth?.userData?.email,
                        host_name: selectedInstructor?.firstName,
                        offeringId: offeringId
                    }))
                    setIsLoading(false)
                    if (confirmedCardPayment.error.decline_code === 'do_not_honor') {
                        window.alert("Your card was declined due to the error `Do hot honor`. Please contact your bank to approve this charge and try again or use another card.")
                    } else {
                        window.alert(confirmedCardPayment.error.message)
                    }
                    
                    return
                }
                
                handleSuccessfulPayment(data, reservationId)
            } else if (reservationId) {
                setIsLoading(false)
                handleSuccessfulPayment(data, reservationId)
            } else if (message) {
                setIsLoading(false)
                window.alert(message)
            } else {
                setIsLoading(false)
                window.alert("Something went wrong after succesful api response")
            }
        } catch (err) {
            setIsLoading(false)
            console.log("wuh oh")
            console.log(err)
            if (err.message) {
                window.alert(err.message)
            } else {
                window.alert(err)
            }
        }
    }

    function handleSuccessfulPayment(data, resId) {

        analytics.track('Purchase', {
            pixelId: selectedInstructor?.instructorProfile?.facebookPixelId,
            value: data.payment,
            name: data.name,
            offeringId: data.id,
            currency: 'USD',
            location: 'OfferingCheckout',
            type: data.type, // pack, dropin, subscription
            offering: data.name
        })

        const {match} = props
        console.log("match: ", match)
        var URL =  match.url.replace("checkout", "confirm")
        if (resId) {
            URL = URL + `?reservation_id=${resId}`
        }
        console.log("match: ", URL)
        history.push(URL)
    }

    // const submit = (event) => {
    //     event.preventDefault();
    //     nextButtonClicked();
    // }

    let height;
    const sendPostMessage = () => {
        let conatinerId = "fullWidthWidget"
        if (document.getElementById(conatinerId)) {
            if (height !== document.getElementById(conatinerId).offsetHeight) {
                height = document.getElementById(conatinerId).offsetHeight;
                window.parent.postMessage({
                  frameHeight: height
                }, '*');
                // console.log(height);
              }
        }
        
    }
    useEffect(() => {
        sendPostMessage()
    })
    return (
    <div className="container">
        <Helmet>
            <title>{selectedOffering?.name ?? "Checkout"}</title>
        </Helmet>
        {(selectedOffering) ? (
            <div className="row">
                <div className="col-sm-12 col-md-6 col-lg-6"> 
                    {viewModel.image && (
                        <PreviewImage className="mb-4" imageUrl={viewModel.image} />
                    )}
                    
                    <Form.Group>

                        <div className='d-flex d-column justify-content-between'>
                            <h2 className="font-weight-bold">{viewModel.name}</h2>
                            {!viewModel.promoCodePurchaseOnly && viewModel.frequency === "subscription" && (
                                <div className="text-right">
                                    <h6 className="font-weight-bold mb-1">{viewModel.priceText}</h6>
                                    <p className="font-weight-bold">{viewModel.frequencyText}</p>
                                </div>
                            )}
                        </div>
                        <div className="mt-3 offeringDescription">
                            {viewModel.descriptionHTML ? (
                                <>
                                {viewModel.descriptionHTML}
                                </>
                            ) : (
                                <>
                                {viewModel.description}
                                </>
                            )}
                            
                        </div>
                    </Form.Group>

                </div>
                <div className="col-sm-12 col-md-6 col-lg-6">
                    {checkoutData?.offering?.type === "challenge" && checkoutData.offerings && !viewModel.disableCheckout && (
                        <>
                        <Form.Group>
                            <OfferingSelector
                            {...checkoutData}
                            // onChange={(model) => console.log(`got the model: ${model}`)}
                            onChange={(model) => {
                                // console.log(model)
                                setCheckoutModel(model)
                            }}
                            />
                        </Form.Group>
                        <hr/>
                        </>
                    )}
                    <LoginSignupForm
                    mode={'signup'}
                    onComplete={() => "Logged in successfully"}
                    titleCopy="Login for access"
                    />
                    <div className='mt-3'>
                        <Form.Group>
                            {viewModel.liabilityWaiverText && (<>
                                <br></br>
                                <ExpandableTerms terms={viewModel.liabilityWaiverText} />
                                <Form.Check 
                                checked={agreeToTerms}
                                type="checkbox"
                                id="terms-checkbox"
                                onChange={(e) => setAgreeToTerms(e.target.checked)}
                                label={`I agree to the Liability Waiver`}
                                />
                            </>)}
                            {viewModel.showMarketingOptIn && (
                                <Form.Check 
                                    checked={marketingEmails}
                                    type="checkbox"
                                    id="marketing-switch"
                                    onChange={(e) => setMarketingEmails(e.target.checked)}
                                    label={`I agree to receive newsletters + product updates from ${viewModel.instructorName}.`}
                                />
                            )}
                        </Form.Group>
                    </div>

                    {viewModel?.formResponse && viewModel.formResponse.fields?.length > 0 && (
                        <div className="mt-3">
                            <CustomFormFields formResponse={viewModel.formResponse} handleUpdate={setFormData} />
                            
                        </div>
                    )}
                    <hr/>
                    {viewModel.showPayment && checkoutData?.paymentMethods && (
                        <Form.Group>
                            <PaymentMethodSelector
                            {...checkoutData}
                            paymentMethods={checkoutData.paymentMethods}
                            // onChange={(model) => console.log(`got the model: ${model}`)}
                            onChange={(model) => {
                                console.log(model)
                                setSelectedPaymentMethod(model)
                            }}
                            />
                        </Form.Group>
                    )}
                    {viewModel.showPayment && !selectedPaymentMethod && (
                        <CardSection className="w-100 mb-5" />
                    )}

                    {checkoutData && checkoutModel && (
                        <CheckoutPricingSection
                        checkoutData={checkoutData}
                        checkoutModel={checkoutModel}
                        handleCouponCodeChange={handleCouponCodeChange}
                        handleCouponCodeApply={handleCouponCodeApply}
                        isLoading={isLoading}
                        handlePricingOptionChange={(model) => {
                            setSelectedPricingOption(model)
                            setCheckoutModel({
                                ...checkoutModel,
                                pricingOption: model
                            })
                        }}
                        />
                    )}
                    
                    <div className="d-flex flex-row justify-content-center">
                        {viewModel.isPurchasable ? (
                            <Button disabled={isLoading || viewModel.disableButton} onClick={() => nextButtonClicked()} style={{width: "50%"}} className="primaryColor my-4" variant="primary">
                                {viewModel.nextbuttonstring}
                                {isLoading && (
                                    <Spinner
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden={true}
                                    className="ml-2"
                                >
                                    <span className="sr-only">Sending...</span>
                                </Spinner>

                                )}
                            </Button>

                        ) : (
                            <div className=" text-center my-3">
                                This offering cannot be purchased. You either already own this offering, or it can only be used by first time clients.
                            </div>
                        )}
                    </div>

                    {viewModel?.frequencyText && viewModel.payment > 0 && (
                        <p className="text-center" style={{fontSize: 'smaller'}}>
                            By starting the service, you authorize us to charge your credit or debit card, agree to our <a className="primaryColor" target="_blank" href="https://www.sutra.fit/terms">Terms of Service</a> &amp; <a className="primaryColor" target="_blank" href="https://www.sutra.fit/privacy">Privacy Policy</a>, and represent that you are at least 16 years of age. <strong className="font-weight-bold">Your subscription will automatically renew until canceled.</strong> To cancel at anytime please visit your purchases in your profile or contact your instructor at <a className="primaryColor" target="_blank" href={"mailto:" + selectedInstructor.email}>{selectedInstructor.email}</a>.
                        </p>
                    )}
                </div>

                
            </div>
        ) : (
            <div className='align-self-stretch container text-center my-auto pt-5'>
                <Spinner className='mt-5' animation="grow"/>
            </div>
        )}
    </div>
    );
}

export default OfferingCheckout;
